/** @jsxRuntime classic */
/** @jsx isolateComponent */

import { css } from '@emotion/react';
import { Button, ButtonProps, Colors, Typography } from '@zapier/design-system';
import { labelStyles, isolateComponent } from '@zapier/style-encapsulation';
import { MEDIA_MIN_WIDTH } from '../../constants';

export interface CustomButtonProps extends Omit<ButtonProps, 'color'> {
  color?: 'primary' | 'secondary' | 'secondary-alt';
}

const Styles = labelStyles('CustomButton', {
  root: (color: 'primary' | 'secondary' | 'secondary-alt') =>
    css({
      '& > a, & > button': {
        backgroundColor: {
          primary: Colors.neutral800,
          secondary: Colors.neutral100,
          'secondary-alt': Colors.peach,
        }[color],
        color: color === 'primary' ? Colors.neutral100 : Colors.neutral800,
        border: 'none',

        '&[data-size="large"]': {
          ...Typography.heading,
          fontWeight: 500,
          fontSize: '16px',
          height: '50px',

          [MEDIA_MIN_WIDTH.large]: {
            ...Typography.subHeader3Medium,
            height: '70px',
          },
        },

        '&:hover:not([disabled])': {
          backgroundColor: {
            primary: Colors.night,
            secondary: Colors.blue20,
            'secondary-alt': Colors.neutral100,
          }[color],
          color: color === 'primary' ? Colors.neutral100 : Colors.neutral800,
          boxShadow: 'none',
        },
      },
    }),
});

export function CustomButton({
  color = 'primary',
  ...props
}: CustomButtonProps) {
  return (
    <div css={Styles.root(color)}>
      <Button
        {...props}
        color={color === 'primary' ? 'primary-alt' : 'secondary'}
        size="large"
      />
    </div>
  );
}
